import { cva, type VariantProps } from 'class-variance-authority';

/**
 * LineClamp variants for truncating content to a fixed number of lines.
 * Uses Tailwind core `line-clamp-*` utilities (available by default in Tailwind CSS v3+).
 * `whitespace-pre-line` keeps author newlines while still wrapping and collapsing spaces.
 */
export const preservedLineBreaks =
  'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line';

// Each variant is a complete class string. Tailwind's scanner does not
// evaluate interpolated names, so a helper would drop these utilities.
export const lineClampVariants = cva('', {
  variants: {
    lines: {
      none: '',
      1: 'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line line-clamp-1 [&_.inline-copy-host]:line-clamp-1',
      2: 'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line line-clamp-2 [&_.inline-copy-host]:line-clamp-2',
      3: 'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line line-clamp-3 [&_.inline-copy-host]:line-clamp-3',
      4: 'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line line-clamp-4 [&_.inline-copy-host]:line-clamp-4',
      5: 'whitespace-pre-line [&_.inline-copy-host]:whitespace-pre-line line-clamp-5 [&_.inline-copy-host]:line-clamp-5',
    },
  },
  defaultVariants: {
    lines: 'none',
  },
});

export type LineClampVariantProps = VariantProps<typeof lineClampVariants>;
